import * as React from 'react';
import { match } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { InformationPersonCard } from './components/InformationPersonCard';
import ViewButtons from '../share/ViewButtons/ViewButtons';
import { ICase } from 'src/share/types/case/case';
import './person.css';
import NotFoundData from '../share/NotFoundData/NotFoundData';

export interface IPersonProps {
  caseData: ICase;
  history: any;
  loading: boolean;
  match: match<{ caseId: string }>
  permissionCase: boolean
  isAnETLCase: boolean
}

export interface IPersonState {
  personType: string;
}

export default class Person extends React.Component<IPersonProps, IPersonState> {
  constructor(props: IPersonProps) {
    super(props);
    this.state = {
      personType: ''
    }
  }

  public static getDerivedStateFromProps(props: IPersonProps, state: IPersonState) {
    const { path } = props.match;
    const personType = path.startsWith('/case/children') ? 'children' : 'abductors';
    return {
      ...state,
      personType
    };
  }

  public render() {
    const { caseId } = this.props.caseData;
    const { personType } = this.state;
    const persons = this.props.caseData[personType];
    return (
      <div className="person-content">
        <div className="help-loader">
          <BeatLoader loading={this.props.loading} />
        </div>
        {!this.props.loading ? persons && persons.length > 0 ?
          persons.map((person, index) =>
            <InformationPersonCard caseId={caseId} person={person} personType={personType} key={index} history={this.props.history}/>
          ) : <NotFoundData label={'No companions assigned for this case'} />
          : <></>}
        <ViewButtons
          history={this.props.history}
          match={this.props.match}
          caseData={this.props.caseData}
          loading={this.props.loading}
          permissionCase={this.props.permissionCase}
          isAnETLCase={this.props.isAnETLCase} />
      </div>
    );
  }
}
